import { v4 as uuidv4 } from 'uuid';
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, Grid, Stack, Slider, Divider, useTheme, Button, CircularProgress, Collapse, TextField, InputAdornment} from '@mui/material';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import TuneIcon from '@mui/icons-material/Tune';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';

import { BrandKitico } from '../../../Icons';
import { SectionHeader } from './common/section.header';
import { Tab, TabPanel, TabsList } from './common/section.tabbar';

import { opacityMarks } from './tooltap.config';
import { ProjectJSON_Store } from '../../../store/actions/projectdata';
import { GetProjectUUID } from '../../../assets/script/commonFunction';
import { BASE_BACKEND_URL, getAssets, getProjectJSON, SERVER_STATUS } from '../../../axios/ApiProvider';
import { changeZeroSecond, copyObject, getMaxZIndex, getSelectedType } from '../commonFunction';
import { changedJSON_Store, thumbNails_Store, uploadingFiles_Store } from '../../../store/actions/projectdata';
import { getNewVideoInformation, getImageInformation, getThumbnails, getDuration, getVideoAssetFps, getNewAudioInformation } from '../webGL/commonFunc';
import { dataLoaded_Store, VideoElements_Store, imageElements_Store, audioElements_Store } from '../../../store/actions/webgldata';
import webcamCaptureIcon from "../../../assets/image/icons/webcam-capture.png"
import screenCaptureIcon from "../../../assets/image/icons/screen-capture.png"
import { CaptureDialog_Store } from "../../../store/actions/editAction"
import { webGlSizeOptions } from '../../video-edit/videoEdit.config';
import PricingModal from '../../../pages/Pricing/pricingModal';  ;

let tempVideoEls = null;
let tempAudioEls = null;
let tempProjectJSON = null;
let tempLoadingData = null;
let tempAssets

const inputStyle = { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer'};
export const TooltapUpload = () => {
  const dispatch = useDispatch();
  const projectUUID = GetProjectUUID();
  const languageStrs = useSelector((store) => store.editdata.languageStrs)
  const HeaderInfo = { title: languageStrs.media_upload, className: 'pl-3' };
  const loginState = useSelector((store) => store.maindata.loginState);
  const thumbNails = useSelector(store => store.projectdata.thumbNails);
  const ProjectJSON = useSelector(store => store.projectdata.projectJSON);
  const sequenceNumber = useSelector(store => store.projectdata.sequenceNumber);
  const videoElements = useSelector(store => store.webgldata.videoElements);
  const audioElements = useSelector(store => store.webgldata.audioElements);
  const imageElements = useSelector(store => store.webgldata.imageElements);
  const uploadingFiles = useSelector((store) => store.projectdata.uploadingFiles);
  const Time_Count = useSelector((store) => store.videodata.Time_Count);
  const theme = useTheme();
  const menuRef = useRef(null);
  const [downloadingAssetId, setDownloadingAssetId]= useState(null);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  
  const [nextPageUrl, setNextPageUrl] = useState(null);
  const [pretPageUrl, setPretPageUrl] = useState(null);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [rightClickedAsset, setRightClickedAsset] = useState(null);
  const [userAssets, setUserAssets] = useState([]);
  const [assets, setAssets] = useState([]);
  const [assetSearch, setAssetSearch] = useState('');
  const assetSearchRef = useRef('');
  useEffect(() => { tempVideoEls = { ...videoElements } }, [videoElements]);
  useEffect(() => { tempAudioEls = { ...audioElements } }, [audioElements]);
  useEffect(() => { 
    tempProjectJSON = { ...ProjectJSON };
    allAssets();
  }, [ProjectJSON]);
  useEffect(() => { tempLoadingData = { ...uploadingFiles } }, [uploadingFiles]);

  const [userData, setUserData] = useState({})
  const [userPlan, setUserPlan] = useState(0);
  useEffect(() => {
    let tempData = {}
    let item = localStorage.getItem('user_data')
    if (!!item && JSON.parse(item)?.state === 'loggedin') tempData = JSON.parse(item)
    setUserData(tempData)
    setUserPlan(tempData.subscription)
  }, [loginState])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setRightClickedAsset(null);
      }
    };

    const handleScroll = () => {
      setRightClickedAsset(null);
    };

    if (rightClickedAsset) {
      document.addEventListener("mousedown", handleClickOutside);
      window.addEventListener("scroll", handleScroll, true);   
      document.addEventListener("scroll", handleScroll, true); 
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll, true);
      document.removeEventListener("scroll", handleScroll, true);
    };
  }, [rightClickedAsset]);

  const [showPricingPageModal, setShowPricingPageModal] = useState(false)
  const handleClosePricingModal = () => {
    setShowPricingPageModal(false)
  }

  const allAssets = async (url) =>{
    const q = assetSearchRef.current;
    const fetchUrl = url || (BASE_BACKEND_URL + "/user/assets/" + (q ? `?search=${encodeURIComponent(q)}` : ""));
    const assetData = await getAssets(fetchUrl);
    if (assetSearchRef.current !== q) return; // stale response (search changed while fetching)

    if(assetData.state ==="success") {
      setUserAssets(assetData.data.results);
      setNextPageUrl(assetData.data.next);
      setPretPageUrl(assetData.data.previous);    
    } else{
      console.error(assetData.data.message);
    }
  }

  useEffect(() => {
    const q = assetSearch.trim();
    if (q === assetSearchRef.current) return;
    const t = setTimeout(() => { assetSearchRef.current = q; allAssets(); }, 400);
    return () => clearTimeout(t);
  }, [assetSearch]);

  const buildProjectAsset = (assetData) => {
    const tmpAsset = assetData;
    const assetKeys = Object.keys(tmpAsset);
    let assetList = [];
    assetKeys.map(astKey => {
      const astItem = tmpAsset[astKey];
      const astThumKeys = Object.keys(astItem.thumbnail);
      let astThumbs = [];
      astThumKeys.map(astThKey => {
        astThumbs.push(astItem.thumbnail[astThKey]);
      })
      astThumbs.sort((a, b) => { return a.timestamp - b.timestamp; });
      assetList.push({
        name: astItem.filename,
        thumbNail: astThumbs.length>0?astThumbs[0].signed_url : ''
      })
    })
    setAssets(assetList);
  }


  const chooseVideoFunc = async ({ target }) => {
    if (!target || !target.files[0]) {
      window.toastr.warning('file select error')
      return
    }

    const newUUID = uuidv4();
    let videofile = target.files[0];
    const videoLength = Object.keys(tempVideoEls).length;

    let video_type = videofile.type;
    let allow_type = ['video/mp4', 'video/webm', 'video/quicktime'];
    let accep_type = allow_type.find((type) => type === video_type);

    if (!accep_type) {
      window.toastr.error("Can't load this video file")
      return
    }

    let duration = await getDuration(videofile)
    if (duration === Infinity) {
      window.toastr.info('video type error', 'can`t load this video')
      return
    }

    let fps = await getVideoAssetFps(videofile)
    console.log("THIS IS FPS : ", fps);
    // if (fps === 0) {
    //   window.toastr.info('video type error, cant get fps', 'can`t load this video')
    //   return
    // }

    console.log("VideooFile Size : " + videofile.size + " duration : " + duration + " user plan " + userPlan)
    let msg = "";
    if (loginState) {
      if (userPlan == 0) {
        if (videofile.size > 1024 * 1024 * 1024) {
          msg = 'You cannot upload files larger than 1 Gbyte, please ugprade your subscription to upload larger files';
        }
        if (duration > 10 * 60) {
          msg = 'You cannot upload files longer than 10 minutes, please upgrade your subscription to upload longer videos';
        }
      } else if ((userPlan == 1) || (userPlan == 4)) {
        if (videofile.size > 10 * 1024 * 1024 * 1024) {
          msg = 'You cannot upload files larger than 10 Gbyte, please ugprade your subscription to upload larger files';
        }
        if (duration > 25 * 60){
          msg = 'You cannot upload files longer than 25 minutes, please upgrade your subscription to upload longer videos';
        }
      }
      else if ((userPlan == 2) || (userPlan == 3) || (userPlan == 5) || (userPlan == 6))  {
        if (videofile.size > 50 * 1024 * 1024 * 1024) {
          msg = 'You cannot upload files larger than 50 Gbyte, contact info@kedy.ai';
        }
        if( duration > 720 * 60){
          msg = 'In order to upload files longer than 2 hours, contact info@kedy.ai';
        }
      }
      let storage_flag = userData?.storage_usage_state
      if (!storage_flag) {
        msg = 'You have run out of Cloud Storage Space with your current plan, please upgrade your subscription for more cloud space.';
      }
    } else {
      if (videofile.size > 250 * 1024 * 1024) {
        msg = 'You cannot upload files larger than 250 Mbytes, please signup and ugprade your subscription to upload larger files';
      }
      if (duration > 5 * 60) {
        msg = 'You cannot upload files longer than 5 minutes, please signup and upgrade your subscription to upload longer videos';
      }
    }
    if (msg !== "") {
      window.toastr.info(msg)
      setShowPricingPageModal(true);
      return
    }

    let newProjectJSON = {...ProjectJSON}

    let fileData = { pc: 0, type: 'video', name: videofile.name, state: false }
    dispatch(uploadingFiles_Store({ ...uploadingFiles, [newUUID]: fileData }));

    let tempThumbNails = [];
    let _thumbNails = await getThumbnails(videofile, 1);

    _thumbNails.forEach((thumbNail) => {
      let tempData = {
        uuid: uuidv4(),
        content_type: 'blob',
        timestamp: thumbNail.time,
        signed_url: URL.createObjectURL(thumbNail.file)
      }

      tempThumbNails.push(tempData);
    });

    let maxZIndex = getMaxZIndex(ProjectJSON);
    let props = [newProjectJSON, videofile, '', duration, fps, newUUID, projectUUID, videoLength, maxZIndex]

    getNewVideoInformation(...props, 
      async (videoPlayer, videoInfo, isNewGroup) => {
      dispatch(thumbNails_Store({ ...thumbNails, [newUUID]: tempThumbNails }));
      let changedJSON = {fps: fps, timelinerowlabel: {}, videos: {}, audios: {}, images: {}, asset: {}, text: {} }
      let startTime = Time_Count.getTime()

      console.log("getNewVideoInformation videoInfo : ", videoInfo);

      /*videoInfo = {
        ...videoInfo,
        timeline_start: startTime,
        timeline_end: videoInfo.duration + startTime
      }*/

      videoInfo = {
        ...videoInfo,
        fps: fps,
      }

      changedJSON.flag = true
      if(isNewGroup){
        changedJSON.timelinerowlabel = {"video": [videoInfo.groups]}
      }

      changedJSON.fps    = fps;
      changedJSON.videos = { [newUUID]: videoInfo }
      
      const titleHasDefaultPrefix = typeof ProjectJSON?.title === 'string' && ProjectJSON.title.startsWith('Project - ');
      if ((Number(sequenceNumber?.c) === 0 || Object.keys(ProjectJSON?.videos || {}).length === 0) && titleHasDefaultPrefix) {
        changedJSON.title = videofile.name.replace(/\.[^/.]+$/, "");
      }
      dispatch(VideoElements_Store({ ...tempVideoEls, [newUUID]: videoPlayer }));
      dispatch(changedJSON_Store(changedJSON));
      changeZeroSecond(videoInfo, dispatch)
    },
    (tempAssets) => {
      let changedData = { videos: {}, audios: {}, images: {}, asset: {}, text: {} }
      changedData = { ...changedData, asset: { ...tempAssets } };
      dispatch(changedJSON_Store(changedData));
    },
    async (newAssets, assetUUID) => {
      let changedData = { videos: {}, audios: {}, images: {}, asset: {}, text: {} }
      if (!tempProjectJSON.videos[newUUID]) return;
      changedData.videos[newUUID] = tempProjectJSON.videos[newUUID];
      // changedData.videos[newUUID].asset_uuid = assetUUID;

      const JSONdata = await getProjectJSON(projectUUID);
      const projectData = (JSONdata && JSONdata.data && (JSONdata.data[projectUUID] || JSONdata.data)) || null;

      if (JSONdata.state !== 'success' || SERVER_STATUS === 'localhost' || !projectData || !projectData.asset) {
        changedData = { ...changedData, asset: { ...newAssets } };
      } else {
        changedData = { ...changedData, asset: projectData.asset };
      }

      // let fileItem = { ...tempLoadingData[newUUID], state: true };
      // dispatch(uploadingFiles_Store({ ...tempLoadingData, [newUUID]: fileItem }))
      dispatch(changedJSON_Store(changedData));
    },
    () => { dispatch(dataLoaded_Store(true)); }, 
    (e) => {
      let pc = parseFloat(e.loaded / e.total * 100).toFixed(2);
      let fileItem = { ...tempLoadingData[newUUID], pc: Number(pc) };
      dispatch(uploadingFiles_Store({ ...tempLoadingData, [newUUID]: fileItem }))
      if(Number(pc) === 100) {
        setTimeout(() => {
          let fileItem = { ...tempLoadingData[newUUID], pc: Number(pc), state: true };
          dispatch(uploadingFiles_Store({ ...tempLoadingData, [newUUID]: fileItem }))
        }, 1000)
      }
    })
  }

  const chooseAudioFunc = async ({ target }) => {
    if (!target || !target.files[0]) {
      window.toastr.warning('file select error')
      return
    }

    const newUUID = uuidv4();
    let audiofile = target.files[0];
    let audio_type = audiofile.type;
    let allow_type = ['audio/mp3', 'audio/mpeg', 'audio/wav'];
    let accep_type = allow_type.find((type) => type === audio_type);

    if (!accep_type) {
      window.toastr.error("Can't load this video file")
      return
    }

    let duration = await getDuration(audiofile)
    if (duration === Infinity) {
      window.toastr.info('audio type error', 'can`t load this audio')
      return
    }

    if (!loginState) {
      if (audiofile.size > 250 * 1024 * 1024 || duration > 5 * 60) {
        let title = 'Please sign in or sign up to upload audios'
        let content = 'larger than 250 Mbytes or longer than 5 minutes'
        window.toastr.info(title, content)
        return
      }
    } else {
      let flag = userData?.storage_usage_state
      if (!flag) {
        window.toastr.error('You have run out of Cloud Storage Space with your current plan, you need to upgrade your account to upload files to a project')
        return
      }
    }

    let fileData = { pc: 0, type: 'audio', name: audiofile.name, state: false }
    dispatch(uploadingFiles_Store({ ...uploadingFiles, [newUUID]: fileData }));

    getNewAudioInformation(ProjectJSON, audiofile, duration, newUUID, projectUUID, (audioPlayer, audioInfo) => {
      let changedJSON = { videos: {}, audios: {}, images: {}, asset: {}, text: {} }
      let startTime = Time_Count.getTime()

      const audioKeys = Object.keys(ProjectJSON.audios);
      audioKeys.map(aItemKey => {
        if(startTime < ProjectJSON.audios[aItemKey].timeline_end){
          startTime = ProjectJSON.audios[aItemKey].timeline_end;
        }
      })

      audioInfo.timeline_start = startTime
      audioInfo.timeline_end = audioInfo.duration + startTime
      changedJSON.audios = { [newUUID]: audioInfo }
      dispatch(audioElements_Store({ ...tempVideoEls, [newUUID]: audioPlayer }));
      dispatch(changedJSON_Store(changedJSON));
    }, async (newAssets, assetUUID) => {
      let changedData = { videos: {}, audios: {}, images: {}, asset: {}, text: {} }
      if (!tempProjectJSON.audios[newUUID]) return;
      changedData.audios[newUUID] = tempProjectJSON.audios[newUUID];

      const JSONdata = await getProjectJSON(projectUUID);
      const projectData = JSONdata?.data[projectUUID];

      if (JSONdata.state !== 'success' || SERVER_STATUS === 'localhost') {
        changedData = { ...changedData, asset: { ...newAssets } };
      } else changedData = { ...changedData, asset: projectData.asset };

      let fileItem = { ...tempLoadingData[newUUID], state: true };
      dispatch(uploadingFiles_Store({ ...tempLoadingData, [newUUID]: fileItem }))
      dispatch(changedJSON_Store(changedData));
    }, () => { dispatch(dataLoaded_Store(true)) }, (e) => {
      let pc = parseFloat(e.loaded / e.total * 100).toFixed(2);
      let fileItem = { ...tempLoadingData[newUUID], pc: Number(pc) };
      dispatch(uploadingFiles_Store({ ...tempLoadingData, [newUUID]: fileItem }))
    })
  }

  const chooseImageFunc = async (e) => {
    if (!e || !e.target || !e.target.files[0]) window.toastr.warning('file select error');
    if (!e || !e.target || !e.target.files[0]) return;

    if (loginState) {
      let flag = userData?.storage_usage_state
      if (!flag) {
        window.toastr.error('You have run out of Cloud Storage Space with your current plan, you need to upgrade your account to upload files to a project')
        return
      }
    }

    const newUUID = uuidv4();
    let imgFile = e.target.files[0];
    const newImgUrl = URL.createObjectURL(imgFile);
    const originalFileName = imgFile.name;
    const mimeType = imgFile.type;

    let fileData = { pc: 0, type: 'image', name: imgFile.name, state: false }
    dispatch(uploadingFiles_Store({ ...uploadingFiles, [newUUID]: fileData }));
    dispatch(dataLoaded_Store(false));


    let maxZIndex = getMaxZIndex(ProjectJSON);
    
    let props = [ProjectJSON, originalFileName, mimeType, newImgUrl, newUUID, projectUUID, 'image', maxZIndex]
    await getImageInformation(...props, async (img, imageInfo) => {
      let imgThumbNail = [{ uuid: uuidv4(), content_type: 'blob', signed_url: newImgUrl }];
      dispatch(thumbNails_Store({ ...thumbNails, [imageInfo.asset_uuid]: imgThumbNail }));
      let changedJSON = { videos: {}, audios: {}, images: {}, asset: {}, text: {} }
      let startTime = Time_Count.getTime()
      const imgKeys = Object.keys(ProjectJSON.images);
      if(imgKeys.length > 0){
        // imgGroupId = imgKeys[0];
        imgKeys.map(keyItem => {
          if(startTime < ProjectJSON.images[keyItem].timeline_end){
            startTime = ProjectJSON.images[keyItem].timeline_end;
          }
        })
      }
      imageInfo = {
        ...imageInfo,
        timeline_start: startTime,
        timeline_end: imageInfo.duration + startTime
      }

      changedJSON.images = {
        [newUUID]: imageInfo
      }

      dispatch(imageElements_Store({ ...imageElements, [newUUID]: img }));
      dispatch(changedJSON_Store(changedJSON));
      changeZeroSecond(imageInfo, dispatch)
    }, async (newAssets, assetUUID) => {
      let changedData = { videos: {}, audios: {}, images: {}, asset: {}, text: {} }
      if (!tempProjectJSON.images[newUUID]) return;
      //changedData.images[newUUID] = tempProjectJSON.images[newUUID]

      const JSONdata = await getProjectJSON(projectUUID);
      const projectData = JSONdata?.data[projectUUID];

      if (JSONdata.state !== 'success' || SERVER_STATUS === 'localhost')
        changedData = { ...changedData, asset: { ...newAssets } };
      else changedData = { ...changedData, asset: projectData.asset };

      let fileItem = { ...tempLoadingData[newUUID], state: true };
      dispatch(uploadingFiles_Store({ ...tempLoadingData, [newUUID]: fileItem }))
      dispatch(changedJSON_Store(changedData));
    }, () => { dispatch(dataLoaded_Store(true)); }, (e) => {
      let pc = parseFloat(e.loaded / e.total * 100).toFixed(2);
      let fileItem = { ...tempLoadingData[newUUID], pc: Number(pc) };
      dispatch(uploadingFiles_Store({ ...tempLoadingData, [newUUID]: fileItem }))
    });
  }

  const handleOpenWebcamCaptureDialog = () => {
    dispatch(CaptureDialog_Store({
      webcam: true
    }))
  }

  const handleOpenScreenCaptureDialog = () => {
    dispatch(CaptureDialog_Store({
      screen: true
    }))
  }

  const handleOpenWSCaptureDialog = () => {
    dispatch(CaptureDialog_Store({
      webcamScreen: true
    }))
  }

  const nextPage = () => {
    allAssets(nextPageUrl);
  }

  const prePage = () => {
    allAssets(pretPageUrl);
  }

  const handleDownloadAsset = async () => {
    const asset = userAssets.find((a) => a.uuid === rightClickedAsset.uuid);
    if (!asset?.signed_url) return;
    setDownloadingAssetId(asset.uuid);
    setRightClickedAsset(null);

    try {
      const response = await fetch(asset.signed_url);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      const ext = asset.signed_url.split(".").pop().split(/\#|\?/)[0];
      link.download = asset.title ? `${asset.title}` : `download.${ext}`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed", err);
    }
    setDownloadingAssetId(null);
    setRightClickedAsset(null);
  }

  const toggleOptions = () => {
    setShowMoreOptions(!showMoreOptions);
  } 

  return (
    <>
      <Box md={12} className='px-10 pt-0'>
        <TabsUnstyled defaultValue={0}>
          <TabPanel value={0} md={12}>
            <Box className={`v-input-container ${theme.palette.mode === 'dark' ? 'dark' : 'light'} v-font-2-5 pr-3 pl-3 mt-4`} >
              <Box className='v-pointer input-text' >{languageStrs.upload_video}</Box>
              <input type={`file`} style={inputStyle}
                accept=".mp4, .m4v, .webm, .mov"
                onChange={chooseVideoFunc}
              />
              <BackupOutlinedIcon className='v-font-5' />
            </Box>

            <Box className={`v-input-container ${theme.palette.mode === 'dark' ? 'dark' : 'light'} v-font-2-5 pr-3 pl-3 mt-4`} >
              <Box className='v-pointer input-text' >{languageStrs.upload_audio}</Box>
              <input type={`file`} style={inputStyle}
                accept=".mp3, .mpeg, .wav" onChange={chooseAudioFunc}
              />
              <BackupOutlinedIcon className='v-font-5' />
            </Box>

            <Box className={`v-input-container ${theme.palette.mode === 'dark' ? 'dark' : 'light'} v-font-2-5 pr-3 pl-3 mt-4`} >
              <Box className='v-pointer input-text' >{languageStrs.upload_image}</Box>
              <input type={`file`} style={inputStyle}
                accept=".jpg, .jpeg, .png, .svg, .gif"
                onChange={chooseImageFunc}
              />
              <BackupOutlinedIcon className='v-font-5' />
            </Box>

            <Button
              style ={{width: "100%"}}
              variant='contained'
              onClick={toggleOptions}
              sx={{ mt: 1, mb: 1 }}
            >
              {showMoreOptions === false ? <TuneIcon /> : <CloseIcon />}
              MORE OPTIONS
            </Button>

            <Collapse in={showMoreOptions} timeout={300}> 
              <Box className={`v-input-container ${theme.palette.mode === 'dark' ? 'dark' : 'light'} v-font-2-5 pr-3 pl-3 mt-4`} onClick={handleOpenWebcamCaptureDialog} >
                <Box className='v-pointer input-text' >{languageStrs.create_webcam_recording}</Box>
                <img src={webcamCaptureIcon} width={30} height={30} alt="webcam capture icon" />
              </Box>

              <Box className={`v-input-container ${theme.palette.mode === 'dark' ? 'dark' : 'light'} v-font-2-5 pr-3 pl-3 mt-4`} onClick={handleOpenScreenCaptureDialog} >
                <Box className='v-pointer input-text' >{languageStrs.create_screen_capture_recording}</Box>
                <img src={screenCaptureIcon} width={30} height={30} alt="screen capture icon" />
              </Box>

              <Box className={`v-input-container ${theme.palette.mode === 'dark' ? 'dark' : 'light'} v-font-2-5 pr-3 pl-3 mt-4 mb-8`} onClick={handleOpenWSCaptureDialog} >
                <Box className='v-pointer input-text' >{languageStrs.create_webcam_screen_recording}</Box>
                <Box display="flex" >
                  <img src={webcamCaptureIcon} width={30} height={30} alt="webcam capture icon" />
                  <img src={screenCaptureIcon} width={30} height={30} alt="screen capture icon" />
                </Box>
              </Box>
            </Collapse>            
            {/* <Box className='v-input-container v-font-2-2 pr-3 pl-3 mt-4' >
              <Box className='v-pointer input-text' >Upload Audio</Box>
              <input type={`file`} style={inputStyle}
                accept=".MP3, .MP4, .M4A"
              />
              <BackupOutlinedIcon className='v-font-3-3' />
            </Box> */}
          </TabPanel>
          {(userAssets.length > 0 || assetSearch.trim() !== '' || assetSearchRef.current !== '') && <>
             <Divider />
             <Typography align='center'>User Assets</Typography>
             <Divider sx={{ mb: 1 }} />

            <Box sx={{ px: 1, pb: 1.5 }}>
              <TextField
                size="small"
                fullWidth
                value={assetSearch}
                onChange={(e) => setAssetSearch(e.target.value)}
                placeholder={languageStrs.search || 'Search'}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
                sx={{ '& .MuiOutlinedInput-root': { height: 40, alignItems: 'center' }, '& .MuiOutlinedInput-input': { height: 'auto', py: 0, lineHeight: 1.5 }, '& .MuiOutlinedInput-notchedOutline': { inset: 0 }, '& .MuiOutlinedInput-notchedOutline legend': { display: 'none' } }}
              />
              {assetSearch.trim() !== '' && userAssets.filter(assetData => assetData.signed_url).length === 0 &&
                <Typography variant="body2" align="center" color="text.secondary" sx={{ pt: 1 }}>No results</Typography>
              }
            </Box>

            <Box display="flex" justifyContent="center" paddingBottom={1.5}>
              <Stack direction="row" spacing={2}>
                <Button onClick={prePage} variant="contained" startIcon={<SkipPreviousIcon />} disabled={!!pretPageUrl ? false : true}>
                  {languageStrs.previous}
                </Button>

                <Button onClick={nextPage} variant="contained" endIcon={<SkipNextIcon />} disabled={!!nextPageUrl ? false : true}>
                  {languageStrs.next}
                </Button>
              </Stack>
            </Box> 
           </>
           }
          
          <TabPanel value={0}>
            <Grid container spacing={3} display="flex"  alignItems="center">
              {userAssets.filter(assetData => assetData.signed_url).map((assetData) => (
                <Grid item md={3} key={assetData.uuid}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedAsset(assetData); 
                    }}
                    onContextMenu={(e) => {
                      e.preventDefault(); 
                      setRightClickedAsset({
                        uuid: assetData.uuid,
                        x: e.clientX,
                        y: e.clientY,
                      }); 
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    {downloadingAssetId === assetData.uuid ? (
                      <Box display="flex" justifyContent="center" alignItems="center">
                        <CircularProgress />
                      </Box>
                    ) : (
                      <img
                        src={assetData.export_thumbnail}
                        alt={assetData.title}
                        style={{
                          width: "150px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "6px",
                          backgroundColor: !assetData.export_thumbnail ? "gray" : "transparent",
                        }}
                      />
                    )}
                    
                  </a>
                </Grid>
              ))}
            </Grid>

            
            {rightClickedAsset &&
              userAssets.find((a) => a.uuid === rightClickedAsset.uuid)
                ?.signed_url && (
                <div
                  
                  ref={menuRef}
                  style={{
                    position: "fixed",
                    top: rightClickedAsset.y,
                    left: rightClickedAsset.x,
                    background: "#01579b",
                    backgroundColor: theme.palette.background.paper,
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    padding: "4px 0",
                    zIndex: 10000,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                >

                <div
                  style={{
                    display: "block",
                    padding: "6px 12px",
                    fontSize: "0.85rem",
                    color: "white",
                    cursor: "pointer",
                    textDecoration: "none",
                    fontFamily: "'Poppins', sans-serif",
                    
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#55555541")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                  onClick={handleDownloadAsset}
                >
                  <FileDownloadIcon style={{ marginRight: "6px"}}/>
                  Download
                </div>                    
                </div>
              )}

            {selectedAsset && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "rgba(0,0,0,0.6)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 9999,
                }}
                onClick={() => setSelectedAsset(null)} 
              >
                <div
                  style={{
                    background: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    maxWidth: "80%",
                    maxHeight: "80%",
                    overflow: "auto",
                    position: "relative",
                  }}
                  onClick={(e) => e.stopPropagation()} 
                >
                  
                  {(selectedAsset.category === 1 || selectedAsset.category === 2) && selectedAsset.signed_url && (
                    <video
                      controls
                      style={{ maxWidth: "100%", maxHeight: "70vh", borderRadius: "8px" }}
                    >
                      <source src={selectedAsset.signed_url} type="video/mp4" />
                    </video>
                  )}
                  {selectedAsset.category === 3 && selectedAsset.signed_url && (
                    <img
                      src={selectedAsset.signed_url}
                      alt={selectedAsset.title}
                      style={{ maxWidth: "100%", maxHeight: "70vh", borderRadius: "8px" }}
                    />
                  )}
                </div>
              </div>
            )}

          </TabPanel>
          {/* <TabPanel value={1}>
            <Stack md={12} className='v-hoverborder v-radius p-3 mt-4'>
              <Grid container spacing={0} className='v-BrandKit'>
                <Grid item xs={10}>
                  <Typography className='v-BrandKit-text'>Brand Kit</Typography>
                  <Typography className='v-BrandKitbottom-text'>Upgrade to PRO to unlock</Typography>
                </Grid>

                <Grid item xs={2}>
                  <Box className='v-BrandKit-icon'>
                    <BrandKitico />
                  </Box>
                </Grid>
              </Grid>
            </Stack>

            <Typography className='v-block-footer mt-2'>Remove background noise and enhance audio quality</Typography>
          </TabPanel> */}
        </TabsUnstyled>
      </Box>
      <PricingModal open={showPricingPageModal} onCloseModal={handleClosePricingModal} />
    </>
  )
}